import React from 'react';
import PropTypes from 'prop-types';
import Icon from "components/Icon";
import css from './CollaboratorLinksBlock.module.scss';

const CollaboratorLinksBlock = ({
    heading,
    collaborators,
    readMoreText,
    readMoreLink
}) => {
    
    return <div className={css.block}>
        <div className={css.container}>
            {heading && 
            <h2 className={css.heading}>{heading}</h2>
            }
            {collaborators && 
            <ul className={css.collaborators}>
                {collaborators.map((a, index) => {
                    const WrapperTag = a.link ? 'a' : 'div';
                    return (
                        <li key={index}  className={css.collaborators__item}>
                            <WrapperTag  className={css.collaborators__content} href={a.link}>
                                <span className={css.collaborators__title}>{a.title}</span>
                                {a.isExternal && <Icon icon="icon-share" className={css.icon} />}
                            </WrapperTag>
                        </li>
                    );})}
            </ul>
            }
            {readMoreLink && readMoreText && 
            <a href={readMoreLink} className={css.readMore}>{readMoreText}</a>
            }</div>
    </div>;
};

CollaboratorLinksBlock.propTypes = {
    heading: PropTypes.string,
    collaborators: PropTypes.arrayOf(PropTypes.shape({
        title: PropTypes.string,
        link: PropTypes.string,
        isExternal: PropTypes.bool
    })),
    readMoreText: PropTypes.string,
    readMoreLink: PropTypes.string
};

export default CollaboratorLinksBlock;


// WEBPACK FOOTER //
// ./src/components/CollaboratorLinksBlock/CollaboratorLinksBlock.jsx